import http from '../../../api/axios';
import { apiUrl } from '../../../api/apiUrl';
import { Values } from '../../../forms/NumericalSeries/NumericalSeriesForm.types';
import { handleApiErrors } from '../../../api/apiErrorHandler';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { NumericalSeriesForm } from '../../../forms/NumericalSeries/NumericalSeriesForm';
import { NumericalSeries } from '../../../types/NumericalSeries';
import { Loader } from '../../../components/loader/Loader';
import { NumericalSeriesCounters } from '../NumericalSeriesCounter/NumericalSeriesCounterPage';
import { useTranslation } from '../../../context/translationContext';
import { paths } from '../../RouterContainer';
import { COMPANY_TABS } from '../Company/UserCompaniesUpdatePage';
import { useBreadcrumbs } from '../../../hooks/useBreadcrumbs';
import { useLoading } from '../../../context/loadingContext';

/**
 * Page component for editing existing numerical serie of company
 */
export const NumericalSeriesUpdatePage = () => {
  const { companyId, id } = useParams();
  const { t } = useTranslation();
  const [data, setData] = useState<NumericalSeries | null>(null);
  const navigate = useNavigate();
  const { setBreadcrumbs } = useBreadcrumbs();
  const { startLoading, stopLoading } = useLoading();
  const isCurrent = window.location.pathname.includes(`current`);
  useEffect(() => {
    setBreadcrumbs([
      {
        path: `${paths.MY_COMPANIES}`,
        name: 'navigation.my-companies',
      },
      {
        path: `${paths.MY_COMPANIES}/edit/${isCurrent ? `current` : companyId}`,
        name: 'navigation.company-setting',
      },
      {
        path: `${paths.MY_COMPANIES}/${isCurrent ? `current` : companyId}/${
          paths.NUMERICAL_SERIES
        }/edit/${id}`,
        name: 'navigation.numerical-series-edit',
      },
    ]);
  }, []);
  /**
   * Back button action
   */
  const handleOnBack = () =>
    navigate(`/${paths.MY_COMPANIES}/edit/${isCurrent ? `current` : companyId}`, {
      state: { tab: COMPANY_TABS.NUMERICAL_SERIES },
    });

  /**
   * Loads numerical serie
   */
  const fetchData = async () => {
    const response = await http.apiGet({
      url: `${apiUrl.NUMERICAL_SERIES_ITEM}?id=${id}`,
    });
    setData(response?.data);
  };

  useEffect(() => {
    fetchData();
  }, []);

  /**
   * Handles edit action for new company bank account form submit.
   * @param values form data
   */
  const handleSubmit = async (values: Values) => {
    try {
      startLoading();
      const response = await http.apiPut({ url: apiUrl.NUMERICAL_SERIES_UPDATE, data: values });
      if (response?.status === 200) {
        stopLoading();
        toast.success('Success!');
      }
    } catch (err) {
      stopLoading();
      handleApiErrors(err);
    }
  };

  if (!data) return <Loader />;
  return (
    <>
      <div className="flex flex-row">
        <div className="w-1/4	space-y-8">
          <h1 className="text-3xl font-bold">{t('page.numerical-serie.headline-edit')}</h1>
          <NumericalSeriesForm
            onSubmit={handleSubmit}
            initialValues={data as Values}
            onBack={handleOnBack}
          />
        </div>
        <NumericalSeriesCounters counters={data.numericalSeriesCounters} />
      </div>
    </>
  );
};
